/* patch-inner.js - inner page behaviours (loads after theme.js) */
(function(){
  /* Shipping & Delivery accordion: one panel open at a time, like the live vc_tta accordion */
  document.addEventListener('click',function(ev){
    var a=ev.target.closest('.zsh__hd a');if(!a)return;ev.preventDefault();
    var panel=a.closest('.zsh__panel'),acc=panel.parentNode,open=panel.classList.contains('is-open');if(open)return;
    acc.querySelectorAll('.zsh__panel').forEach(function(p){p.classList.remove('is-open');var b=p.querySelector('.zsh__body');if(b)b.hidden=true;});
    if(!open){panel.classList.add('is-open');var b=panel.querySelector('.zsh__body');if(b)b.hidden=false;}
  });
})();
(function(){
  /* WPBakery/skrollr parallax (speed 1.5): inner top runs -50% (band top at viewport bottom) -> 0% (inner bottom at viewport top) */
  var els=[].slice.call(document.querySelectorAll('[data-zpar]'));if(!els.length)return;
  function tick(){var vh=window.innerHeight;els.forEach(function(el){var hero=el.parentNode;var r=hero.getBoundingClientRect();var top=r.top+window.scrollY,h=r.height;var a=top-vh,b=top+1.5*h;var p=(window.scrollY-a)/(b-a);p=Math.min(1,Math.max(0,p));el.style.top=(-50*(1-p))+'%';});}
  window.addEventListener('scroll',tick,{passive:true});window.addEventListener('resize',tick);tick();
})();
(function(){
  /* Shipping mobile tabs (live vc_tta tabs: UNITED STATES / INTERNATIONAL) */
  document.addEventListener('click',function(ev){
    var a=ev.target.closest('[data-zsh-tab]');if(!a)return;ev.preventDefault();
    var tta=a.closest('[data-zsh-tta]'),i=a.getAttribute('data-zsh-tab');
    tta.querySelectorAll('.zsh__tab').forEach(function(t){t.classList.remove('is-active')});
    a.parentNode.classList.add('is-active');
    tta.querySelectorAll('.zsh__tpanel').forEach(function(p){p.classList.toggle('is-active',p.getAttribute('data-zsh-panel')===i)});
  });
})();
(function(){
  /* Fitting room: live leaves every size/fit toggle CLOSED on a phone (measured at 390:
     three 26px rows at y1161/1187/1213). Desktop keeps the first panel open. */
  function sync(){
    if(window.matchMedia('(max-width:767.98px)').matches){
      document.querySelectorAll('.zfr__panel[open]').forEach(function(p){
        if(!p.dataset.zfrUser) p.removeAttribute('open');
      });
    }
  }
  document.addEventListener('toggle',function(e){
    var p=e.target.closest&&e.target.closest('.zfr__panel');if(p)p.dataset.zfrUser='1';
  },true);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',sync);else sync();
})();
